const DocumentType = {
  USER_DOCS: 'USER_DOCS',
  ADD_USER_DOCS: 'ADD_USER_DOCS',
  DELETE_USER_DOC: 'DELETE_USER_DOC',
  CLEAR: 'CLEAR',
  GET_USERS_GROUPS_CARD: 'GET_USERS_GROUPS_CARD',
  POST_USERS_GROUPS_CARD: 'POST_USERS_GROUPS_CARD',
  DELETE_USERS_GROUPS_CARD: 'DELETE_USERS_GROUPS_CARD',
  UPDATE_USERS_GROUPS_CARD: 'UPDATE_USERS_GROUPS_CARD',
  GET_USERGROUPS_BYID: 'GET_USERGROUPS_BYID',
  PUT_USERGROUPS: 'PUT_USERGROUPS',
  // ****library****
  GET_USERS_LIBRARY_LIST: 'GET_USERS_LIBRARY_LIST',
  GET_SUPPLIER_USERS_LIST: 'GET_SUPPLIER_USERS_LIST',
  UPDATE_USERS_LIBRARY_STATUS: 'UPDATE_USERS_LIBRARY_STATUS',
  DELETE_USERS_LIBRARY: 'DELETE_USERS_LIBRARY',
  UPDATE_USERS_LIBRARY: 'UPDATE_USERS_LIBRARY',
  RESET_USERS_PASSWORD: 'RESET_USERS_PASSWORD',
  ADD_USERS: 'ADD_USERS',
  EDIT_USERS: 'EDIT_USERS',
  FETCH_OPTIONS: 'FETCH_OPTIONS',
  // *****Check-user-rights****
  FETCH_USER_RIGHTS: 'FETCH_USER_RIGHTS',
  MODULE_ACCESS_RIGHTS: 'MODULE_ACCESS_RIGHTS',
  SECTION_ACCESS_RIGHTS: 'SECTION_ACCESS_RIGHTS',
  SUBSCRIPTION_PERMISSION: 'SUBSCRIPTION_PERMISSION',
  ADMIN_RIGHTS_ACCESS: 'ADMIN_RIGHTS_ACCESS',
  // *******User Profile Details******
  PROFILE_DETAILS: 'PROFILE_DETAILS',
  CURRENCY_PERMISSION: 'CURRENCY_PERMISSION',
  STORAGE_USER_BY_SYSTEM_BY_SLUG: 'STORAGE_USER_BY_SYSTEM_BY_SLUG',
};

export default DocumentType;
